import { Chip } from "@mui/joy";
import { useTranslation } from "react-i18next";

export function BetaBadge(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Chip
      size="sm"
      variant="solid"
      sx={{
        fontWeight: 700,
        letterSpacing: 1,
        borderRadius: "6px",
        lineHeight: 1,
        height: 20,
        backgroundColor: "#1976D2",
        color: "#FFFFFF",
        "&:hover": {
          backgroundColor: "#1565C0",
        },
      }}
    >
      {t("betaBadge.beta")}
    </Chip>
  );
}

export default BetaBadge;
